import { stringify, ParsedUrlQuery } from 'querystring';

import { SearchQueryParams } from '../types/SearchQuery';
import filterParams from '../../common/utils/filterParams';

const API_NEARBY_SEO_ROUTE = '/api/v4/rutter/v1/search/seo/nearby/?';

type NearbySeoQueryParams = Pick<SearchQueryParams, 'category_slug'>;

const ALLOWED_PARAMS: (keyof NearbySeoQueryParams)[] = [
  'category_slug',
];

/**
 * Returns the nearby seo url for the specified query.
 * Unrecognized params will be removed.
 * The params are ordered alphabetically.
 */
const getNearbySeoUrl = (
  query: ParsedUrlQuery,
): string => API_NEARBY_SEO_ROUTE + stringify(
  filterParams<NearbySeoQueryParams>({
    query,
    allowedParams: ALLOWED_PARAMS,
    defaultParams: { category_slug: 'boat-rental' },
  }),
);

export default getNearbySeoUrl;
